import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_URL = "https://wa.me/message/VNF5QD3LGOP6A1";

// Floating WhatsApp button, rendered once at the app root so it appears on
// every page.
const WhatsappFloat = () => (
    <a
        className="whatsapp-float"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatea con nosotros por WhatsApp"
    >
        <FaWhatsapp aria-hidden="true" />
    </a>
);

export default WhatsappFloat;
